import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  listAdsCampaigns: {
    method: 'GET',
    url: `${configs.baseUrl}/api/ads-campaign`,
  },
  getAdsCampaign: {
    method: 'GET',
    url: `${configs.baseUrl}/api/ads-campaign/{adsCampaignId}`,
  },
  createAdsCampaign: {
    method: 'POST',
    url: `${configs.baseUrl}/api/ads-campaign`,
  },
  deleteAdsCampaign: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/ads-campaign/{adsCampaignId}`,
  },
  patchAdsCampaign: {
    method: 'PATCH',
    url: `${configs.baseUrl}/api/ads-campaign/{adsCampaignId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const listAdsCampaigns = async (params) => {
  const res = await resource.listAdsCampaigns(params)

  return res.body
}

const getAdsCampaign = async (adsCampaignId) => {
  const res = await resource.getAdsCampaign({
    adsCampaignId
  })

  return res.body
}

const createAdsCampaign = async (params) => {
  const res = await resource.createAdsCampaign(params)

  return res.body
}

const deleteAdsCampaign = async (adsCampaignId) => {
  const res = await resource.deleteAdsCampaign({
    adsCampaignId
  })

  return res.body
}

const patchAdsCampaign = async (adsCampaignId, params) => {
  const res = await resource.patchAdsCampaign({
    adsCampaignId
  }, params)

  return res.body
}

export default {
  initResource,
  listAdsCampaigns,
  getAdsCampaign,
  createAdsCampaign,
  deleteAdsCampaign,
  patchAdsCampaign,
}